import React from 'react';
import { Avatar } from 'antd';
import { useSelector } from 'react-redux';

/**
 * Round driver avatar — the uploaded driver photo, falling back to the driver's
 * initials when none is set. Shown everywhere a driver surfaces (Drivers list,
 * Routes table, route detail, day-plan timeline, …). Callers pass the driver's
 * `name` + `photoKey` (the File.key from whatever projection they have); the GCS
 * host comes from the authenticated user (Redux). Mirrors PartnerLogo, but round
 * (a person, not a logo).
 */
const initials = (name) => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  return (
    parts
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .filter(Boolean)
      .join('') || '?'
  );
};

export default function DriverAvatar({ name, photoKey, size = 24, style }) {
  const host = useSelector((s) => s.auth?.user?.host);
  const src = host && photoKey ? `${host}/${photoKey}` : null;

  if (src) {
    return <Avatar src={src} size={size} shape="circle" style={{ flexShrink: 0, ...style }} />;
  }
  return (
    <Avatar
      size={size}
      shape="circle"
      style={{
        flexShrink: 0,
        background: '#e6eef7',
        color: '#3f6ea5',
        fontSize: Math.max(9, Math.round(size * 0.42)),
        fontWeight: 600,
        ...style,
      }}
    >
      {initials(name)}
    </Avatar>
  );
}
